/* Tunn hook för den som föredrar hook-stil framför de importerade funktionerna.
   Returnerar samma kpConfirm/kpPrompt — ingen egen state, ingen JSX att rendera. */
import { kpConfirm, kpPrompt } from './dialogApi';

export default function useConfirm() {
  return { confirm: kpConfirm, prompt: kpPrompt };
}
